module.exports = __webpack_public_path__ + "static/media/featureimage3.e1c1e3b0.jpg";